'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Share = function (customProps) {
    var computedProps = tslib_es6.__assign({ width: 20, height: 20, fill: 'currentColor' }, customProps);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 20 20" }, computedProps),
        React__default['default'].createElement("path", { d: "M10 1L5.75 5.24264L6.45711 5.94814L9.5 2.90152V15H10.5V2.90156L13.5426 5.94814L14.2497 5.24264L10 1ZM1 10V19H19V10H18V18H2V10H1Z" })));
};

exports.default = Share;
//# sourceMappingURL=index.js.map
